import React from 'react';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import baseStyles from '../css/Base.module.css';

export default function ExerciseAppBar({exercise, children}) {
  return (
    <AppBar position="sticky" className="bg-brandorange">
      <Toolbar variant="dense">
        <Typography variant="h6" className={baseStyles['f-g-1']}>
          {exercise?.name}
        </Typography>

        {children}
      </Toolbar>
    </AppBar>
  );
}
